import React, { useState,  } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery,
  Grid,
  Divider,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Field } from "formik";
import { setTitleCase, } from "../../../components/template/partials";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import {
  InputText,
} from "../../../components/template/partials";
import * as FileSaver from "file-saver";
import XLSX from 'sheetjs-style';
import { exportCustomer } from "utils/action/customer";
import { toast } from "react-toastify";
import { useRef } from "react";


// inital values form
const initialValues = {
  amount_data: 100,
  file_name: 'Data Pelanggan'
};

// form field validation schema
const validationSchema = Yup.object().shape({
  amount_data: Yup.number().required("Jumlah data harus lebih dari 1"),
});

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

export function ExportCustomerData() {
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const showDialog = location.state?.showDialog ?? false;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const customerData = useRef([])

  const onHide = () => {
    navigate("/customer");
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const request = {
      limit : values.amount_data,
    }

    try {
      const response = await exportCustomer(request);
      const ws = XLSX.utils.json_to_sheet(response.data.result);
      const wb = { Sheets: { 'data': ws}, SheetNames : ['data']};
      const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
      const datas = new Blob([excelBuffer], {type: fileType});
      FileSaver.saveAs(datas, values.file_name + fileExtension);
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
  };

  

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-create-customer-title"
    >
      <DialogTitle id="responsive-dialog-create-customer-title">
        Export Data
      </DialogTitle>
      <Divider />
      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="amount_data"
                    label="Jumlah Data"
                    size="small"
                    variant="outlined"
                    type="number"
                    fullWidth
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="file_name"
                    label="Nama File"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                autoFocus
                onClick={onHide}
                color="error"
                variant="contained"
              >
                Kembali
              </Button>
              <LoadingButton
                autoFocus
                loading={isLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Export
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
